import { Injectable, inject } from '@angular/core';
import { WINDOW } from './window.factory';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {
    private readonly window = inject<Window>(WINDOW);


    locale: string;
    lang: string;
    region: string;
    pathLocale?: string;

    constructor() {

        const locale = this.window['__parkPassLocale'] || {};

        Object.keys(locale).forEach(key => {
            this[key] = locale[key];
        });

    }

    getPathWithLocale(path: string): string {
        return this.pathLocale ? `/${this.pathLocale}${path}` : path;
    }

}
